import { createWebHistory, createRouter } from 'vue-router'
import store from '@/middlewares/store';

import Dashboard from '@/pages/Dashboard.vue';
import Login from '@/pages/Login.vue';
import Users from '@/pages/Users.vue';
import Branches from '@/pages/Branches.vue';
import Expenses from '@/pages/Expenses.vue';
import Customers from '@/pages/Customers.vue';
import Specs from '@/pages/Specs.vue';
import Tires from '@/pages/Tires.vue';
import Prices from '@/pages/Prices.vue';
import Cashier from '@/pages/Cashier.vue';
import Stock from '@/pages/Stock.vue';
import SupplyLog from '@/pages/SupplyLog.vue';
import Privilege from '@/pages/Privilege.vue';
import Transfer from '@/pages/Transfer.vue';
import Invoices from '@/pages/Invoices.vue';
import TransferOrders from '@/pages/transferOrders.vue';
import Logs from '@/pages/Logs.vue';
import Profile from '@/pages/Profile.vue';
import Others from '@/pages/Others.vue';
import Settings from '@/pages/Settings.vue';
import Return from '@/pages/Return.vue';
import Returns from '@/pages/Returns.vue';
import Statistics from '@/pages/Statistics.vue';
//------------------------------------------------------------
const routes = [
    { path: '/login',                       name: 'Login',      component: Login,               meta:{ guard: false } },

    { path: '/',                            name: 'Dashboard',      component: Dashboard,       meta:{ guard: true }  },
    { path: '/statistics',                  name: 'Statistics',     component: Statistics,      meta:{ guard: true }  },
    { path: '/profile',                     name: 'Profile',        component: Profile,         meta:{ guard: true }  },
    { path: '/settings',                    name: 'Settings',       component: Settings,        meta:{ guard: true }  },
    { path: '/users',                       name: 'Users',          component: Users,           meta:{ guard: true }  },
    { path: '/logs/:id?',                   name: 'Logs',           component: Logs,            meta:{ guard: true }, props: true },
    { path: '/privilege/:id',               name: 'Privilege',      component: Privilege,       meta:{ guard: true }, props: true },

    { path: '/branches',                    name: 'Branches',       component: Branches,        meta:{ guard: true }  },
    { path: '/expenses',                    name: 'Expenses',       component: Expenses,        meta:{ guard: true }  },
    { path: '/customers',                   name: 'Customers',      component: Customers,       meta:{ guard: true }  },

    { path: '/specs',                       name: 'Specs',          component: Specs,           meta:{ guard: true }  },
    { path: '/tires',                       name: 'tires',          component: Tires,           meta:{ guard: true }  },
    { path: '/prices',                      name: 'Prices',         component: Prices,          meta:{ guard: true }  },
    { path: '/others',                      name: 'Others',         component: Others,          meta:{ guard: true }  },

    { path: '/sales/cashier',               name: 'Cashier',        component: Cashier,         meta:{ guard: true }  },
    { path: '/sales/invoices/:cid?',        name: 'Invoices',       component: Invoices,        meta:{ guard: true }, props: true },
    { path: '/sales/returns/:iid?',         name: 'Returns',        component: Returns,         meta:{ guard: true }, props: true },
    { path: '/sales/return/:id',            name: 'Return',         component: Return,          meta:{ guard: true }, props: true },

    { path: '/stock/',                      name: 'Stock',          component: Stock,           meta:{ guard: true }  },
    { path: '/stock/transfer',              name: 'Transfer',       component: Transfer,        meta:{ guard: true }  },
    { path: '/stock/transferOrders',        name: 'TransferOrders', component: TransferOrders,  meta:{ guard: true }  },
    { path: '/stock/supplyLog',             name: 'Supply Log',     component: SupplyLog,       meta:{ guard: true }  },
    { path: '/stock/transferLog',           name: 'Transfer Log',   component: SupplyLog,       meta:{ guard: true }  },
    // { path: '/stock/returnLog',             name: 'Return Log',     component: SupplyLog,       meta:{ guard: true }  },

    // { path: '/contact',        name: 'Contact',    component: HomePage, meta:{ guard: '*' }  },
    // { path: '/news',           name: 'News',       component: HomePage, meta:{ guard: '*' }  },
    // { path: '/services',    name: 'Services',   component: ServicesPage, meta:{ guard: '*' }  },
    

    // { path: '/profile',        name: 'Profile',    component: ProfilePage, meta:{ guard: 'user'} },
];
// beforeEnter: (to, from) => {
    //   return true
// },
//------------------------------------------------------------
const router = createRouter({
    history: createWebHistory(),
    routes,
});
//------------------------------------------------------------
router.beforeEach((to, from, next) => {
    document.title = `Romanfly | ${to.name}`;
    if(!to.meta.guard && store.getters.isAuth) return next({ path: '/profile' });
    if(to.meta.guard && !store.getters.isAuth) return next({ path: '/login' });
    next();
});
//------------------------------------------------------------
export default router
